import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import OutlinedInput from "@mui/material/OutlinedInput";
import React, { forwardRef, useId } from "react";



const CustomInputNoLabel = ({
  error = false,
  value,
  onChange,
  helperText = "",
  placeholder = "",
  type,
  startAdornment,
  endAdornment,
  className = "",
  defaultValue,
  onClick,
  disabled = false,
  onKeyPress,
  onPaste,
}) => {
  const id = useId();

  return (
    <FormControl error={error} fullWidth>
      <OutlinedInput
        error={error}
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        className={className}
        defaultValue={defaultValue}
        onClick={onClick}
        disabled={disabled}
        onKeyPress={onKeyPress}
        onPaste={onPaste}
      />
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

// CustomInputWith_forwardRef.displayName = "CustomInput";

// const CustomInputNoLabel = forwardRef(CustomInputWith_forwardRef);

export default CustomInputNoLabel;
